export const Role = {
    Admin: 'ADMIN',
    Client: 'CLIENT',
    Architect: 'ARCHITECT'
}